import { BRAND } from "../../constants/brand";
import React from "react";
import { Row, Col, Image, Modal } from "antd";
import styles from "./index.module.scss";
import MainLayout from "../../components/layout/main-layout";
import bannerImage3 from "../../assets/imrpintbannernew.png";
import { useState } from "react";

import {
  LoveIcon,
  RespectIcon,
  PurposeIcon,
  LaughterIcon,
  LifeIcon,
  SafetyIcon,
  
} from "../../assets/icons";

const values = [
  {
    title: "Love",
    description:
      "A vibrant celebration of every love story, be that partners, friends, family and all, through acceptance and inclusion without judgement across cultures, abilities and differences.",
    thumbnail: "/Images/love.png",
    videoUrl:
      "https://imprintuksouthdev.blob.core.windows.net/web-assets/1543IMP-Values-Love-COMP-V2.mp4",
    icon: LoveIcon,
    badges: [
      {
        name: "Humanity & Inclusion",
        url: "https://www.humanity-inclusion.org.uk/",
      },
      { name: "Samaritans", url: "https://www.samaritans.org/" },
      {
        name: "Respect",
        url: "https://www.respect.org.uk/",
      },
    ],
  },
  {
    title: "Life",
    description:
      "Champion a healthier planet and healthier you through sustainability, conscious choices, and habits that support both personal and environmental well-being.",
    thumbnail: "/Images/life.png",
    videoUrl:
      "https://imprintuksouthdev.blob.core.windows.net/web-assets/1543IMP-Values-Life-COMP-V2.mp4",
    icon: LifeIcon,
    badges: [
      { name: "WaterAid", url: "https://www.wateraid.org/uk" },
      { name: "Friends of the Earth UK", url: "https://friendsoftheearth.uk/" },
      { name: "Doctors Without Borders", url: "https://msf.org.uk/" },
    ],
  },
  {
    title: "Purpose",
    description:
      "Support personal growth through recognition, learning, and self-fulfillment—empowering others to discover and pursue what truly matters to them.",
    thumbnail: "/Images/purpose.png",
    videoUrl:
      "https://imprintuksouthdev.blob.core.windows.net/web-assets/1543IMP-Values-Purpose-COMP-V2.mp4",
    icon: PurposeIcon,
    badges: [
      {
        name: "Room to Read",
        url: "https://www.roomtoread.org/",
      },
      {
        name: "Mental Health Innovations",
        url: "https://mentalhealthinnovations.org/",
      },
      { name: "The Access Project", url: "https://theaccessproject.org.uk/" },
    ],
  },
  {
    title: "Safety",
    description:
      "Promote emotional and physical well-being through spaces to break stigmas, protect rights of all, and inclusive spaces where everyone feels supported and secure.",
    thumbnail: "/Images/safety.png",
    videoUrl:
      "https://imprintuksouthdev.blob.core.windows.net/web-assets/1543IMP-Values-Safety-COMP-V2.mp4",
    icon: SafetyIcon,
    badges: [
      { name: "Oxfam", url: "https://www.oxfam.org.uk/" },
      {
        name: "British Red Cross",
        url: "https://www.redcross.org.uk/",
      },
      { name: "Shelter", url: "https://www.shelter.org.uk/" },
    ],
  },
  {
    title: "Respect",
    description:
      "Honour all forms of life, be that on land, sea or in the air, and seek to build relationships that believe in sharing our planet with compassion and care.",
    thumbnail: "/Images/respect.png",
    videoUrl:
      "https://imprintuksouthdev.blob.core.windows.net/web-assets/1543IMP-Values-Respect-COMP-V2.mp4",
    icon: RespectIcon,
    badges: [
      {
        name: "WWF (World Wide Fund for Nature)",
        url: "https://www.wwf.org.uk/",
      },
      {
        name: "Humanimal Trust",
        url: "https://humanimaltrust.org.uk/",
      },
      { name: "Born Free", url: "https://www.bornfree.org.uk/" },
    ],
  },
  {
    title: "Laughter",
    description:
      "Whether your jokes are so bad they're good or you're a comedic genius, celebrate your inner child with giggles and laughter and share a smile.",
    thumbnail: "/Images/laughter.png",
    videoUrl:
      "https://imprintuksouthdev.blob.core.windows.net/web-assets/1543IMP-Values-Laughter-COMP-V2.mp4",
    icon: LaughterIcon,
    badges: [
      { name: "Papyrus-UK ", url: "https://www.papyrus-uk.org/" },
      { name: "UNICEF", url: "https://www.unicef.org.uk/" },
      { name: "Save the Children", url: "https://www.savethechildren.org.uk/" },
    ],
  },
];

const Values = () => {
  const [openModal, setOpenModal] = useState(false);
  const [activeVideo, setActiveVideo] = useState(null);

  const showModal = (videoUrl) => {
    setActiveVideo(videoUrl);
    setOpenModal(true);
  };

  return (
    <MainLayout>
      <div
        id="herobanner"
        style={{
          background: `url(${bannerImage3}) no-repeat center center/cover`,
        }}
      >
        <div className={styles.heroBanner}>
          <div className={styles.overlay}>
            <h1>Welcome to {BRAND.domainLabel}</h1>
            <p>
              {BRAND.short} is a new kind of social network—designed from the ground
              up to be <span className={styles.highlight}>safer</span>,{" "}
              <span className={styles.highlight}>more mindful</span>, and{" "}
              <span className={styles.highlight}>values-driven</span>.
            </p>
            <Image
              src="/Images/featured.png"
              alt="Illustration"
              className={styles.storyImage}
              loading="lazy"
              preview={false}
            />
          </div>
        </div>
        <div className={styles.valueBox}>
          <Image
            src="/Images/valuebox.png"
            alt="Illustration"
            loading="lazy"
            preview={false}
          />
        </div>
      </div>

      <div className={styles.valuesSection}>
        <h2 className={styles.heading}>Our Values</h2>
        <p className={styles.subheading}>
          We have chosen 6 values that make us fundamentally human using
          Maslow's Hierarchy of Needs. Every post you share can reflect these
          values—and when it does, it gets a Value Badge, helping it reach
          further and create real-world impact.
        </p>
        <p className={styles.subheading}>
          Through posts and reactions, Value Badges can start trending. Each
          Value is associated with three charities, and the users vote which
          charity the money collected from memberships will support.
        </p>
        <p className={styles.subheading}>
          *{BRAND.domainLabel} has no partnerships with or obligations towards any
          charities mentioned on this site.
        </p>
        <Row gutter={[24, 24]}>
          {values.map((item, index) => (
            <Col xs={24} sm={12} md={8} key={index}>
              <div className={styles.card}>
                <div
                  className={styles.thumbnail}
                  style={{ backgroundImage: `url(${item.thumbnail})` }}
                  onClick={() => showModal(item.videoUrl)}
                >
                  <button className={styles.playButton} aria-label="Play Video">
                    ▶
                  </button>
                </div>
                <div className={styles.content}>
                  <div className={styles.valuediv}>
                    <h3>{item.title}</h3>
                    <Image
                      src={item.icon}
                      alt={`${item.title} icon`}
                      preview={false}
                    />
                  </div>
                  <p>{item.description}</p>
                  <div className={styles.badgeContainer}>
                    <ul className={styles.links}>
                      {item.badges?.map((badge, idx) => (
                        <li key={idx}>
                          <a
                            href={badge.url}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            {badge.name}
                          </a>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>
            </Col>
          ))}
        </Row>

        <Modal
          open={openModal}
          footer={null}
          onCancel={() => setOpenModal(false)}
          centered
          width={800}
          className={styles.modal}
          destroyOnClose
        >
          {activeVideo && (
            <div className={styles.videoWrapper}>
              <iframe
                src={`${activeVideo}?autoplay=1&rel=0`}
                referrerPolicy="strict-origin-when-cross-origin"
                title="Value Video"
                frameBorder="0"
                allowFullScreen
                allow="autoplay"
              />
            </div>
          )}
        </Modal>
      </div>

      {/* <AuthFooterComponent />
      <span className="app-version">v{process?.env?.version}</span> */}
    </MainLayout>
  );
};

export default Values;
